import React from 'react';
import { Route, useRouteMatch, Switch, RouteProps, Redirect } from 'react-router-dom';
import { ModuleProps, RouteConfig } from '../../../types';

type RouteModuleFactoryProps = {
  IndexComponent?: React.FC<ModuleProps>;
  redirectPath?: string;
  routes: RouteConfig[];
} & ModuleProps;

const renderRoute = ({ path, Component, ...moduleConfigProps }: RouteConfig): JSX.Element => (
  <Route
    key={path}
    exact
    path={path}
    component={(props: RouteProps): JSX.Element => (
      <Component {...props} {...moduleConfigProps} path={path} />
    )}
  />
);

const RouteModuleFactory: React.FC<RouteModuleFactoryProps> = ({
  IndexComponent,
  redirectPath,
  routes,
  ...moduleProps
}) => {
  const match = useRouteMatch();

  return (
    <React.Fragment>
      <Switch>
        {IndexComponent && (
          <Route
            path={match.path}
            exact
            component={(routeProps: RouteProps): React.ReactElement => (
              <IndexComponent {...routeProps} {...moduleProps} />
            )}
          />
        )}
        {routes.map(renderRoute)}

        {redirectPath && (
          <Route path={'/'} component={(): React.ReactElement => <Redirect to={redirectPath} />} />
        )}
      </Switch>
    </React.Fragment>
  );
};

export default RouteModuleFactory;
